<!--
  购物车
-->
<template>
  <div class="cart-contanier">
    <!--头部-->
    <div class="cart-header" ref="cart_header">
      <div class="back-icon-box">
        <i class="iconfont icon-fanhui1 go-back-icon" @click="goBack" v-show="display.showBackBtn"></i>
      </div>
      <div class="cart-title">购物车</div>
      <div class="edit-cart" @click="openEditCart" v-show="!display.ifEditCarts">编辑</div>
      <div class="edit-cart" @click="closeEditCart" v-show="display.ifEditCarts">完成</div>
    </div>
    <van-loading class="data-loading" color="#45C5DA" v-show="display.showLoading" />
    <!--购物车列表-->
    <div class="cart-list" v-show="!display.nodata" ref="cart_list">
      <van-list
        v-model="display.listLoading"
        :finished="finished"
        :immediate-check="false"
        finished-text="没有更多了"
        @load="loadCarts"
      >
        <div v-for="(shop, shopIndex) in cartList" class="cart-shop-item" :key="shopIndex">
          <div class="checkbox-box">
            <!--结算时用到的复选框-->
            <van-checkbox
              v-show="!display.ifEditCarts"
              :value="shop.checked == 1"
              @click="checkAll(shopIndex, 0)"
            ></van-checkbox>
            <!--编辑购物车时用到的复选框-->
            <van-checkbox
              v-show="display.ifEditCarts"
              :value="shop.editChecked == 1"
              @click="checkAll(shopIndex, 1)"
            ></van-checkbox>
          </div>
          <span class="shop-name">
          <i class="iconfont icon-gongyingshang" style="margin-right: 5px"></i>
          <span>{{ shop.supplierName }}</span>
        </span>
          <div class='cart-item-box' v-for="(item, index) in shop.shopCartList" :key="index">
            <div class="cart-item" >
              <div class="checkbox-box">
                <!--结算时用到的复选框-->
                <van-checkbox
                  v-show="!display.ifEditCarts"
                  :value="item.checked == 1"
                  @click="changeChecked(item, shopIndex, 0)"
                ></van-checkbox>
                <!--编辑购物车时用到的复选框-->
                <van-checkbox
                  v-show="display.ifEditCarts"
                  :value="item.editChecked == 1"
                  @click="changeChecked(item, shopIndex, 1)"
                ></van-checkbox>
              </div>
              <!--商品图片-->
              <img v-bind:src="item.picUrl" alt="" v-lazy="item.picUrl" class="goods-img" />
              <!--商品信息-->
              <div class="goods-info">
                <div class="over2line" @click="gotoDetail(item)">{{ item.goodsName }}</div>
                <span class="goods-standard" @click="selectStandard(item)">
                  <span>{{ item.specificationNames }}</span>
                  <van-icon v-show="item.specificationNames" class="select-standard" name="arrow-down" />
                </span>
                <div>
                  <goodsPrice :price="item.price" :main-size="15" color="#f2270c" style="float:left;"></goodsPrice>
                  <inputNumber
                    :number.sync="item.num"
                    :height="20"
                    :product-id="item.productId"
                    @getNumber="getNumber($event,item)"
                    style="float:right;"
                    :maxNumber="item.productNum"
                  ></inputNumber>
                </div>
              </div>
            </div>
            <div class='handle-cart-box'>
              <div class="delete-cart" @click="openDeleteDialog(item)">删除</div>
              <div class='no-num' v-show='item.productNum == 0'>暂无库存</div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <div class="no-data" v-show="display.nodata">暂无数据</div>
    <!--底部结算模块-->
    <div class="setts-box" ref="settle_box">
      <div class="left-all-check-box">
        <div class="left-check-box">
          <van-checkbox :value="ifcheckAllCart" v-show="!display.ifEditCarts" @click="checkAllCart(0)">
            <span>全选</span>
          </van-checkbox>
          <van-checkbox :value="editIfCheckAllCart" v-show="display.ifEditCarts" @click="checkAllCart(1)">
            <span>全选</span>
          </van-checkbox>
        </div>
      </div>
      <div style="float: right;" v-show="display.ifEditCarts">
        <van-button class="delete-cart-btn" size="small" type="danger" @click="deleteMoreCart">删除</van-button>
      </div>
      <div style="float:right;" v-show="!display.ifEditCarts">
        <div class="setts-btn" :class="{'cannot-settle':!canSettle}" @click="gotoSettle">
          去结算
          <span class="setts-count">({{ selectedCartCount }})</span>
        </div>
        <div class="total-price">
          总计:
          <goodsPrice class="total-price-num" color="#f2270c" :main-size="16" :price="selectedCartPrice"></goodsPrice>
        </div>
      </div>
    </div>
    <!--删除购物车确认框-->
    <van-dialog
      v-model="display.deleteConfirm"
      show-cancel-button
      :message="deleteMessage"
      bind:close="onClose"
      :use-title-slot="true"
      @cancel="closeDialog"
      @confirm="deleteCart"
    >
      <template v-slot:title>
        <van-icon name="warning-o" color="#f2270c" size="40" />
      </template>
    </van-dialog>
    <!--选择规格-->
    <selectStandard
      :ifshow.sync="display.selectStandard"
      :goods-detail="goodsDetail"
      :btn-type="1"
      :iffrom-cart="true"
      :default-standard="selectStandardCart"
      @addCartSuccess="addCartSuccess"
    ></selectStandard>
  </div>
</template>

<script>
import api from 'api/user';
import goodsApi from 'api/goods-list';
import userApi from 'api/user';
import inputNumber from 'components/input-number';
import { Toast } from 'vant';
import selectStandard from 'components/select-standard';

Toast.setDefaultOptions({
  duration: 1500,
});
export default {
  components: { 
    inputNumber,
    selectStandard,
  },
  data() {
    return {
      cartList: [],
      page:{
        pageSize:5,
        pageNumber:1
      },
      display: {
        showLoading: false, //页面加载
        deleteConfirm: false,
        ifEditCarts: false, //是否是编辑购物车状态
        showBackBtn: false, //是否又返回按钮，如果从商品详情页进的购物车页面就又返回按钮
        selectStandard: false,
        nodata: false,
        listLoading: false,//下滑加载
      },
      selectedCart: {}, //选中的购物车（删除时使用）
      ifcheckAllCart: 0, //是否全选商品（结算时）
      editIfCheckAllCart: 0, //是否全选商品（编辑商品时）
      deleteCartIds: '', //批量删除购物车的ids
      goodsDetail: {}, //用于修改购物车规格的商品详情
      selectStandardCart: {}, //修改购物车商品规格的商品
      finished: false,//加载全部购物车
    };
  },
  computed: {
    //已勾选的商品数量
    selectedCartCount() {
      let count = 0;
      this.cartList.map(cart => {
        cart.shopCartList.map(item => {
          if (item.checked) {
            count++;
          }
        });
      });
      return count;
    },
    //已勾选的商品价格
    selectedCartPrice() {
      let price = 0;
      this.cartList.map(cart => {
        cart.shopCartList.map(item => {
          if (item.checked) {
            price += Number(item.num) * (Number(item.price)); //后台返回的是分，转成元
          }
        });
      });

      console.log(price);
      return price;
    },
    //删除确认框的内容
    deleteMessage() {
      return `<div style='font-size:16px;'>${
        this.display.ifEditCarts ? '是否确认删除选中的商品' : '是否确认删除此商品'
      }</div>`;
    },
    canSettle() {
      let judge = false;
      this.cartList.map(cart => {
        cart.shopCartList.map(item => {
          if (item.checked) {
            judge = true;
          }
        });
      });
      return judge;
    }
  },
  //判断是否从商品详情页跳转过来的
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.name === 'goodsDetail') {
        vm.display.showBackBtn = true;
      }
    });
  },
  created() {
    this.display.showLoading = true;
    this.getCart();
  },
  mounted(){
    //计算购物车列表实际高度
    const tabBarHeight = document.getElementsByClassName('tab-bar')[0].offsetHeight;
    const headerHeight = this.$refs.cart_header.offsetHeight;
    const settleHeight = this.$refs.settle_box.offsetHeight;
    this.$refs.cart_list.style.height = window.innerHeight - tabBarHeight - headerHeight - settleHeight + 'px';
    console.log(tabBarHeight, headerHeight,settleHeight);

  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    //购物车商品修改规格
    async selectStandard(item){
      this.display.selectStandard = true;
      const data = await goodsApi.getGoodsById({id:item.goodsId});
      this.selectStandardCart = item;
      this.goodsDetail = data;
      console.log(this.selectStandardCart);
    },
    //修改规格成功
    async addCartSuccess(){
      await userApi.deleteCarts(this.selectStandardCart.id);
      //修改成功后重新获取购物车
      this.page.pageNumber = 1;
      this.display.showLoading = true;
      this.getCart()
    },
    //获取购物车列表
    async getCart() {
      const data = await api.getCart({
        pageSize: this.page.pageSize,
        pageNumber: this.page.pageNumber
      });
      this.display.listLoading = false;
      this.display.showLoading = false;
      if (data.records.length < this.page.pageSize) {
        this.finished = true;
      }
      if (this.page.pageNumber === 1) {
        this.cartList = data.records;
      }else{
        this.cartList = this.cartList.concat(data.records);
      }
      this.ifcheckAllCart = 1;
      if (this.cartList.length > 0) {
        this.display.nodata = false;
        this.cartList.map(item => {
          item.checked = 1;
          item.editChecked = 0;
          //供应商全选按钮的全选状态
          item.shopCartList.map(cart => {
            if (cart.checked === 0) {
              item.checked = 0;
            }
            cart.editChecked = 0;
          });
          //底部全选按钮的全选状态
          if (item.checked === 0) {
            this.ifcheckAllCart = 0;
          }
        });
      }else{
        this.ifcheckAllCart = 0;
        this.display.nodata = true;
      }

    },
    loadCarts(){
      this.page.pageNumber ++;
      this.getCart();
    },
    //修改数量保存
    getNumber(index,item) {
      item.num = index;
      this.updateCart(item);
    },
    //切换勾选
    changeChecked(item, shopIndex, ifEdit) {
      //如果是编辑商品，则修改editChecked属性，否则修改checked属性
      let attr = ifEdit === 0 ? 'checked' : 'editChecked';
      let judge = 1;
      if (ifEdit === 0) { //需要判断库存是否为0，为0则不能勾选
        if(item.productNum == 0) {
          return
        }
      }
      item[attr] = item[attr] === 0 ? 1 : 0;
      //判断当前供应商的全选状态
      this.cartList[shopIndex].shopCartList.map(item => {
        if (item[attr] === 0) {
          judge = 0;
        }
      });
      this.cartList[shopIndex][attr] = judge;
      //判断底部全选按钮的全选状态
      if (!ifEdit) {
        this.judgeAllCheckd1();
        this.updateCart(item); //保存勾选状态
      } else {
        //编辑商品
        this.judgeAllCheckd2();
      }
      this.$forceUpdate();
    },
    //当前供应商全选
    checkAll(index, ifEdit) {
      let attr = ifEdit === 0 ? 'checked' : 'editChecked'; //如果是选择商品，则修改checked属性，如果是编辑购物车，则修改editChecked属性
      this.cartList[index][attr] = this.cartList[index][attr] == 0 ? 1 : 0;
      const checked = this.cartList[index][attr];
      if(ifEdit ===0) { //如果是勾选购物车时
        this.cartList[index].shopCartList.map(item => {
          if(item.productNum == 0) { //判断库存
            item['checked'] = 0;
          }else{
            item['checked'] = checked;
          }
        });
      }else{
        this.cartList[index].shopCartList.map(item => {
          item[attr] = checked;
        });
      }
      if (ifEdit) {
        this.judgeAllCheckd2();
      } else {
        //选择商品
        this.judgeAllCheckd1();
        this.selectCarts(2, checked, this.cartList[index].supplierId);
      }
      this.$forceUpdate()
    },
    //全选购物车
    checkAllCart(ifEdit) {
      if (this.cartList.length === 0) return
      let ifcheck;
      if (!ifEdit) {
        //选择商品
        ifcheck = this.ifcheckAllCart = this.ifcheckAllCart === 0 ? 1 : 0;
      } else {
        //编辑商品
        ifcheck = this.editIfCheckAllCart = this.editIfCheckAllCart === 0 ? 1 : 0;
      }
      let attr = ifEdit === 0 ? 'checked' : 'editChecked'; //如果是选择商品，则修改checked属性，如果是编辑购物车，则修改editChecked属性
      this.cartList.map(cart => {
        cart[attr] = ifcheck;
        if(!ifEdit) {
          cart.shopCartList.map(item => {
            if(item.productNum == 0) { //判断库存
              item['checked'] = 0;
            }else{
              item['checked'] = ifcheck;
            }
          });
        }else{
          cart.shopCartList.map(item => {
            item[attr] = ifcheck;
          });
        }
        
      });
      this.selectCarts(1, ifcheck);
    },
    //批量勾选商品
    selectCarts(type, checked, id) {
      //type:1全选，2选供应商，3选多个购物车
      let params = {
        type,
        checked,
      };
      if (type === 2) params.supplierId = id;
      this.display.showLoading = true;
      api.selectCarts(params).then(() => {
        this.display.showLoading = false;
      });
    },
    //判断选择商品时底部按钮是否全选
    judgeAllCheckd1() {
      let judge1 = 1;
      this.cartList.map(cart => {
        if (cart.checked === 0) {
          judge1 = 0;
        }
      });
      this.ifcheckAllCart = judge1; //是否全选商品（结算时）
    },
    //判断编辑时底部按钮是否全选
    judgeAllCheckd2() {
      let judge2 = 1;
      this.cartList.map(cart => {
        if (cart.editChecked === 0) {
          judge2 = 0;
        }
      });
      this.editIfCheckAllCart = judge2;
    },
    //打开删除购物车确认框
    openDeleteDialog(item) {
      this.display.deleteConfirm = true;
      this.deleteCartIds = item.id;
    },
    //关闭删除购物车确认框
    closeDialog() {
      this.display.deleteConfirm = false;
    },
    //删除购物车
    deleteCart() {
      let ids = this.deleteCartIds;
      api.deleteCarts(ids).then(() => {
        this.getCart();
      });
    },
    //更新购物车
    updateCart(item) {
      const { id, productId, num, checked } = item;
      const params = {
        ...{ id, productId, num, checked },
      };
      this.display.showLoading = true;
      api.updateCarts(params).then(() => {
        this.display.showLoading = false;
        // this.getCart()
      });
    },
    //打开编辑购物车
    openEditCart() {
      this.display.ifEditCarts = true;
      //初始化把所有商品取消勾选
      this.cartList.map(cart => {
        cart.editChecked = 0;
        cart.shopCartList.map(item => {
          item.editChecked = 0;
        });
      });
      this.editIfCheckAllCart = 0;
    },
    //隐藏编辑购物车
    closeEditCart() {
      this.display.ifEditCarts = false;
    },
    //编辑商品批量删除
    deleteMoreCart() {
      let idsArr = [];
      this.cartList.map(cart => {
        cart.shopCartList.map(item => {
          if (item.editChecked) {
            idsArr.push(item.id);
          }
        });
      });
      if (idsArr.length === 0) {
        Toast('请选择要删除的商品');
        return;
      }
      this.display.deleteConfirm = true;
      this.deleteCartIds = idsArr.join(',');
    },
    //结算
    gotoSettle() {
      if (this.canSettle) {
        //设置订单类型为购物车
        localStorage.setItem('settleType', 0);
        this.$router.push({
          path: '/generate-settle',
        });
      }
    },
    //前往商品详情
    gotoDetail(item) {
      console.log(item);
      this.$router.push({
        path:'/goods-detail',
        query:{
          from:'shopCart',
          goodsId:item.goodsId
        }
      })
    }

  },
};
</script>

<style lang="scss" scoped>
@import 'common/sass/theme.scss';
.cart-contanier {
  position: relative;
  width: 100vw;
  background: $light-line-color;
  overflow-y: auto;
  overflow-x: hidden;
  /*头部*/
  .cart-header {
    display: flex;
    height: 44px;
    padding: 0 10px;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    position: relative;
    color: #4a4a4a;
    font-size: 16px;
    border-bottom: 1px solid $light-line-color;
    .back-icon-box {
      width: 20px;
      font-weight: bold;
    }
    cart-title {
    }
    .edit-cart {
      font-size: 14px;
    }
  }
  /*购物车列表*/
  .cart-list {
    .cart-shop-item {
      padding: 10px;
      background: #fff;
      margin-bottom: 15px;
      .checkbox-box {
        display: inline-block;
      }
      .shop-name {
        margin: 0 10px;
        vertical-align: text-bottom;
        font-weight: bold;
        color: $weight-word-color;
      }
      .cart-item-box{
        &:not(:last-child) {
          border-bottom: 1px solid $light-line-color;
        }
      }
      .cart-item {
        display: flex;
        padding: 10px 0;
        align-items: center;
        .goods-img {
          display: inline-block;
          width: 90px;
          height: 90px;
          margin: 0 10px;
        }
        .goods-info {
          flex: 1;
          display: inline-block;
          .goods-standard {
            display: inline-block;
            margin: 5px 0;
            font-size: 12px;
            background: #f7f7f7;
            padding: 0 5px;
            color: #666;
          }
          .select-standard{
            margin-left: 3px;
            vertical-align: sub;
          }
        }
      }
      .handle-cart-box{
        display: flex;
        flex-direction: column;
        text-align: right;
        .delete-cart {
          margin: 5px 0;
          color: $light-color;
          font-size: 12px;
        }
        .no-num{
          color: red;
          font-size: 13px;
        }
      }
    }
  }
  /*底部结算*/
  .setts-box {
    position: fixed;
    bottom: $nav_height;
    width: 100vw;
    height: 50px;
    padding-left: 10px;
    line-height: 50px;
    background: rgba(255, 255, 255, 0.9);
    border-top: 1px solid #f4f4f4;
    box-sizing: border-box;
    .left-all-check-box {
      float: left;
      .left-check-box {
        display: inline-block;
      }
    }
    .setts-btn {
      float: right;
      width: 100px;
      height: 100%;
      margin-left: 5px;
      text-align: center;
      background: $theme-color;
      color: #fff;
      font-weight: bold;
    }
    .cannot-settle{
      background: $lingt-word-color;
    }
    .total-price {
      float: right;
      .total-price-num {
        float: right;
        color: #f2270c;
        font-weight: bold;
      }
    }
    .delete-cart-btn {
      margin-right: 10px;
    }
  }
}
</style>
